export default __webpack_public_path__ + "static/media/Print_Failed.3b72e1ba.png";